import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, onMounted, ref } from 'vue';
import Banner from '~/components/UIComponents/Banner.vue';
import { IBanner } from '~/types/banner';


export default /*#__PURE__*/_defineComponent({
  __name: 'HostingMomentsBanner',
  setup(__props) {

const { $sanityImage, $filmApiService } = useContext();

const banner = ref<IBanner | null>(null);

onMounted(async () => {
  banner.value = await $filmApiService.get<IBanner>(
    'banners/banner-nodes-moments',
  );
});

const logoImage = computed(() => {
  if (!banner?.value?.logoImage) {
    return;
  }
  return $sanityImage.urlFor(banner.value.logoImage).height(111).url();
});

const backgroundImageLarge = computed(() => {
  if (!banner?.value?.landscapeImage) {
    return;
  }
  return $sanityImage.urlFor(banner.value.landscapeImage).width(1920).url();
});

const backgroundImageSmall = computed(() => {
  if (!banner?.value?.landscapeImage) {
    return;
  }
  return $sanityImage.urlFor(banner.value.landscapeImage).width(1550).url();
});

return { __sfc: true,$sanityImage, $filmApiService, banner, logoImage, backgroundImageLarge, backgroundImageSmall, Banner }
}

})